"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var default_1 = require("./default");

exports.Default = default_1.default;

function combineFilters(filters) {
  // TODO: caching
  if (!Array.isArray(filters) || filters.length === 0) return null;
  return function (r, g, b, a) {
    if (a === 0) return false;

    for (var i = 0; i < filters.length; i++) {
      if (!filters[i](r, g, b, a)) return false;
    }

    return true;
  };
}

exports.combineFilters = combineFilters;